var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebhookGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_737_53171",
    transform: "scale(0.03125)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_737_53171",
    width: 32,
    height: 32,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAABKRJREFUWEfFV0FO40gUraqQiAWL9A1AIFihMSfoZofsSB1O0GSLFHdxAuAEOI7EttMnmLREDDsyJyCzRAE1SOwnGwKy4/qjV3JZxgnETLc0XhnH/vX/+++/9+Hsf774e8+XUlbjON5jjH3mnC/jeyK6Y4z9KJVKXc/zcF/4elcCrut+ZYwdcc6rr51AREe+7x8XzaBwAlLKQwQvEvg9SRRKoNls7gkhvpnDlVL9UqmEKg3cllLqkHNuZd45aLfb3ryECyXguu7PTL+/+74PDjDbti0hRPXs7KyPv6WUR0R0mBw64pyveJ43eiuJuQlIKetE9GcS5K7Vaq3U6/XlKIouGWOahECCiHaDIBg0m81LIcQnPFRKzUVhbgKu63qcc5APbD/2ff+oVqtdEVEKt6n48fFxZXNzE+06SZ51Wq1W45cQcF23wzn/giBxHG8/PDwMoij6Z1ZQIURjdXUVaAAdINBvt9vbvy0BpVRjOByCgD9nBVVK7W5sbIxMAkT0w/f9+i8l0Gw2ZR5Sx3FQoe6zuSBGQRCsSCmXlVJ7RPQR4jRvEuZyQEr5yVRk2nBzc3MnhLg0k2E4UC6Xt7rd7u9XwiyzGWMYrwPP8zrJGEKgDMz9Xq/3Zs/z7ZiLQDLfgPUqK8FE1PJ9XyZ6kOoE53zb6MI8EcLvhRLAi/v7+9bCwgJg1z5gRhL3tVot26Z3oTCVQL1er04mEytfRU6OtSBlK8wSk4hA3L+hFUhYKQVeDCBUb7bAtm3tdowxVLllPoAFJy3Qysc53/U8r5sNlkPhNfQH4E+2uBQB27ah4anbEdHB+fm5NpOcE76qbo7jdBhjWrTeuuCWQRBoy9YJ5A9PtB0JdDHXRJQKT2IwM0dtZ2dnuVQqXSUIjoQQXSK6V0oB0XSBSVRSF8hhLGEYpgcQ0fenpydpWRYLwxABT4y5ZIn3WoWO4+jJ6PV6HviE+263O8J9FEVA1CA0gndw27bxUJsN51wzWEoJf08Znxw2Rby3YLZtGw5q9GFQqVR2IVJZsnLOj7njOFln21pfXx/lZz4Zu4Hv+1tAbDKZGBueyiGO46oQ4isRvZBqtHU8Hm8tLS1ZGa8YAAEyUhoEwYf89pM9gXP+4fr6GvY8l2iz0BFCaJFyHCc9890JDIfDDhF9nsf0Wb9jaQGxHceBnWt+IAEQUEOKDNfW1gZKKUjri83XeHv2fcYYxu5+xmFAaKpNSqmVxcVFFkWRJj0cNE/CTq/Xa2ANU0qdGLdLltDG7e2tFcexWc9GaNmsSmFSjDG8Z5LAXngQBAEMDMur0ZsOh4KB8ZlAWiSgfowxKwzD0enp6SAZ1+we2AmCYGrdSkav+vz8zMrlMhKujsfjbr/fHzmOA2SAmr5gXEaI0lE04wg9EELcIQDn/A8IoukbGK2U2r64uHghSJllFWH6cMxKpYJ3qmEYfslUjt812qkUQ0aJqAi7Zx6OiK8sq1NdQu9NAS/c0LZt9Mbs9VMfQqjiOG7kKzcvQopnbEov4gCV8Xh8hJZotPOnJEEgItDuKhFhybzHP55FFw3btrGaY1ThI2ghxO0veEM+RuGF5L/MfZFv/gXiVsYxFPHRdgAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebhookGrey);
export default __webpack_public_path__ + "static/media/webhook_grey.57d543f2847bb55cf068a252a8342b0a.svg";
export { ForwardRef as ReactComponent };